/**
 * Builds a Blob from a copied byte view so the Blob does not retain references
 * to the original backing buffer.
 */
export function createDetachedBlobFromBufferView(
  view: ArrayBufferView,
  options?: BlobPropertyBag
): Blob {
  const bytes = new Uint8Array(view.byteLength);
  bytes.set(new Uint8Array(view.buffer, view.byteOffset, view.byteLength));
  return new Blob([bytes], options);
}
